import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllIdentifiedProblems = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/identified-problems',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

const updateIdentifiedProblem = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/identified-problems/${id}`,
    data: { id: id, ...data },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

const saveIdentifiedProblem = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/identified-problems',
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

const deleteIdentifiedProblem = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/identified-problems/${id}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
}

export default {
  getAllIdentifiedProblems,
  updateIdentifiedProblem,
  deleteIdentifiedProblem,
  saveIdentifiedProblem,
}
